import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { backend_server_address } from '../../../../../backendServer';
import { downloadBlob } from '../../../../utilities/downloadFile';
import { openStoredFile } from '../../../../../capacitor/fileOpener';
import { mediaCacheActive } from '../../../../../capacitor/mediaCache';

const downloadReportById = createAsyncThunk(
    'reports/downloadById',
    async ({ reportId, reportName }, { rejectWithValue }) => {
        return axios
            .get(backend_server_address + '/api/report/' + reportId + '/download/', {
                withCredentials: true,
                responseType: 'blob',
            })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                return rejectWithValue(error.response.data);
            });
    },
);

export const reportsDownloadSlice = createSlice({
    name: 'reportsDownload',
    initialState: { error: null, loading: 'idle' },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(downloadReportById.pending, (state, action) => {
                if (state.loading === 'idle') {
                    state.loading = 'pending';
                }
            })
            .addCase(downloadReportById.fulfilled, (state, action) => {
                // console.log('reports download slice, fullfilled case', {state, action});
                if (state.loading === 'pending') {
                    window.gtag('event', 'report_download', {
                        event_label: action.meta.arg.reportName,
                        event_category: 'report',
                    });
                    state.loading = 'idle';
                    state.error = null;

                    downloadBlob(action.payload.data, action.meta.arg.reportName);
                }
            })
            .addCase(downloadReportById.rejected, (state, action) => {
                if (state.loading === 'pending') {
                    state.loading = 'idle';
                    state.error = action.error;
                }
            });
    },
});

// Action creators are generated for each case reducer function
// const { setDatesR } = dateSelectorSlice.actions;

export const downloadReport = (params) => downloadReportById(params);

/**
 * Opens a report. In the app it opens the file at the report's signed `url` in the phone's
 * viewer. On the web, and for a report with no `url`, it is the browser download.
 */
export const openReport =
    ({ reportId, reportName, url }) =>
    (dispatch) => {
        const download = () => dispatch(downloadReport({ reportId, reportName }));
        if (!url) {
            download();
            return;
        }
        openStoredFile(url, undefined, download);
        if (mediaCacheActive()) {
            window.gtag('event', 'report_download', { event_label: reportName, event_category: 'report' });
        }
    };

export const selectLoadingState = () => (state) =>
    state.reportsDownload ? state.reportsDownload.loading === 'pending' : false;
export const selectDownloadError = () => (state) => (state.reportsDownload ? state.reportsDownload.error : undefined);
const reportsDownload = reportsDownloadSlice.reducer;
export default reportsDownload;
